var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSentIconChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.946234 1.92726C0.807061 1.33943 1.00508 0.720493 1.45203 0.341223C1.89898 -0.0380471 2.51373 -0.107005 3.02589 0.163782L17.1898 7.65247C17.6868 7.91485 18.001 8.45221 18.001 9.04004C18.001 9.62787 17.6868 10.1652 17.1898 10.4276L3.02589 17.9163C2.51373 18.1871 1.89898 18.1181 1.45203 17.7389C1.00508 17.3596 0.807061 16.7406 0.946234 16.1528L2.42943 9.88099L11.0423 9.04004L2.42943 8.19909L0.946234 1.92726Z",
    fill: "#FFAD00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentIconChat);
export default __webpack_public_path__ + "static/media/sent-icon-chat.46c1920c3c475948e324fb40e64e4f12.svg";
export { ForwardRef as ReactComponent };